import { type RecategorizeCategoryType } from '../../../types/enums.ts';

export type RecategorisationShortcut = {
    keys: string[];
    category: RecategorizeCategoryType;
};

export function recategorisationShortcuts(canArchive: boolean): RecategorisationShortcut[] {
    const bookingDocumentShortcuts: RecategorisationShortcut[] = [
        { keys: ['1'], category: 'invoice' },
        { keys: ['2'], category: 'pos_receipt' },
        { keys: ['3'], category: 'credit_card_statement' },
    ];
    if (!canArchive) {
        return bookingDocumentShortcuts;
    }
    return [...bookingDocumentShortcuts, { keys: ['4'], category: 'archive' }];
}
